import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Rol, Usuario } from '../usuario.model';

export interface RolesDialogData {
  usuario: Usuario;
  rolesDisponibles: Rol[];
}

@Component({
  selector: 'app-gu-roles-dialog',
  templateUrl: './roles-dialog.component.html',
  styleUrls: ['./roles-dialog.component.scss']
})
export class RolesDialogComponent implements OnInit {
  selected = new Set<number>();

  constructor(
    public dialogRef: MatDialogRef<RolesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RolesDialogData
  ) {}

  ngOnInit(): void {
    (this.data.usuario.rol || []).forEach(r => this.selected.add(r.id));
  }

  toggle(rolId: number): void {
    if (this.selected.has(rolId)) this.selected.delete(rolId);
    else this.selected.add(rolId);
  }

  isSelected(rolId: number): boolean { return this.selected.has(rolId); }

  cancel(): void { this.dialogRef.close(null); }

  save(): void {
    if (this.selected.size === 0) return;
    this.dialogRef.close(Array.from(this.selected));
  }
}
